import React from 'react';
import styles from '../index.module.scss';

type Props = {
  children: React.ReactNode;
};

export const BreadcrumbList: React.FC<Props> = ({ children }) => (
  <ol className={styles.list}>{children}</ol>
);
